import { Component, OnInit } from '@angular/core';
import { MonitoramentoService } from './monitoramento.service';

@Component({
  selector: 'app-monitoramento-job',
  templateUrl: './monitoramento-job.component.html',
  styleUrls: ['./monitoramento-job.component.css']
})
export class MonitoramentoJobComponent implements OnInit {

  dados: any[];
  loading: boolean;
  cols: any[];

  constructor(private service: MonitoramentoService) { }

  ngOnInit() {

    this.cols = [
      { field: 'job', header: 'Job', width: '500px' },
      { field: 'ultimaExecucao', header: 'Ultima Execução', width: '500px' }
    ];

    this.service.buscar('/monitorar_job').subscribe({
      next: (res) => {
        this.dados = res;
      }
    })

  }

}
